import type { AuthContextType } from './types'
import type { ReactNode } from 'react'

import { createContext, useContext } from 'react'

import { AuthStatus } from './types'

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const AuthProvider = ({
  children,
  value
}: {
  children: React.ReactNode
  value: AuthContextType
}): ReactNode => <AuthContext.Provider value={value}>{children}</AuthContext.Provider>

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export function useAuthStatus(): AuthStatus {
  const { user } = useAuth()

  return user ? AuthStatus.Authenticated : AuthStatus.Unauthenticated
}
